import { render, staticRenderFns } from "./PeriodDuration.vue?vue&type=template&id=d0f60172&scoped=true"
import script from "./PeriodDuration.vue?vue&type=script&lang=js"
export * from "./PeriodDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f60172",
  null
  
)

export default component.exports